import React from "react";
import Select from "react-select";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowUp } from "@fortawesome/free-solid-svg-icons";
import Input from "../Builder/nodes/Logic/Inputs/Input";
import MyIcon from "../Common/MyIcon";
import InputLabel from "../Builder/nodes/Logic/Inputs/InputLabel";
import { unitConversions } from "./WeatherAlertConstants";

function WeatherConditionValueSelector({
  detail,
  index,
  detailIndex,
  handleConditionDetailChange,
}) {
  // Handle weather codes
  if (detail.selectedCondition.codes) {
    if (detail.ConditionOperator === "betweenx") {
      return (
        <div>
          <InputLabel>Condition Value</InputLabel>
          <div className="d-flex gap-2">
            <Select
              className="react-select-container"
              classNamePrefix="react-select"
              value={
                detail.ConditionValue[0] !== undefined
                  ? {
                      value: detail.ConditionValue[0],
                      label: detail.selectedCondition.codes.find(
                        (code) => code.value === detail.ConditionValue[0]
                      )?.label,
                    }
                  : null
              }
              onChange={(selected) => {
                const min = selected ? parseFloat(selected.value) : null;
                const max =
                  detail.ConditionValue[1] !== undefined
                    ? detail.ConditionValue[1]
                    : null;
                handleConditionDetailChange(
                  detailIndex,
                  "ConditionValue",
                  [min, max],
                  index
                );
              }}
              formatOptionLabel={formatWeatherCodeOption(detail)}
              options={filterWeatherCodes(detail)}
              placeholder="Min"
            />
            <span className="align-self-center">and</span>
            <Select
              className="react-select-container"
              classNamePrefix="react-select"
              value={
                detail.ConditionValue[1] !== undefined
                  ? {
                      value: detail.ConditionValue[1],
                      label: detail.selectedCondition.codes.find(
                        (code) => code.value === detail.ConditionValue[1]
                      )?.label,
                    }
                  : null
              }
              onChange={(selected) => {
                const min =
                  detail.ConditionValue[0] !== undefined
                    ? detail.ConditionValue[0]
                    : null;
                const max = selected ? parseFloat(selected.value) : null;
                handleConditionDetailChange(
                  detailIndex,
                  "ConditionValue",
                  [min, max],
                  index
                );
              }}
              formatOptionLabel={formatWeatherCodeOption(detail)}
              options={filterWeatherCodes(detail)}
              placeholder="Max"
            />
          </div>
        </div>
      );
    }
    return (
      <div>
        <InputLabel>Condition Value</InputLabel>
        <Select
          isMulti={
            detail.ConditionOperator === "=" ||
            detail.ConditionOperator === "between"
          }
          key={detail.Condition}
          className="react-select-container"
          classNamePrefix="react-select"
          value={detail.ConditionValue.map((val) => ({
            value: val,
            label: detail.selectedCondition.codes.find(
              (code) => code.value === val
            )?.label,
          }))}
          onChange={(selectedOptions) => {
            const values = selectedOptions
              ? Array.isArray(selectedOptions)
                ? selectedOptions.map((option) => parseFloat(option.value))
                : [parseFloat(selectedOptions.value)]
              : [];
            handleConditionDetailChange(
              detailIndex,
              "ConditionValue",
              values,
              index
            );
          }}
          formatOptionLabel={formatWeatherCodeOption(detail)}
          options={filterWeatherCodes(detail)}
        />
      </div>
    );
  }
  // Handle wind directions
  if (detail.selectedCondition.windDirections) {
    return (
      <div>
        <InputLabel>Wind Direction</InputLabel>
        <Select
          isMulti
          key={detail.Condition}
          className="react-select-container"
          classNamePrefix="react-select"
          value={detail.ConditionValue.map((val) => ({
            value: val,
            label: detail.selectedCondition.windDirections.find(
              (dir) => dir.degrees === val
            )?.direction,
          }))}
          onChange={(selectedOptions) => {
            const values = selectedOptions
              ? Array.isArray(selectedOptions)
                ? selectedOptions.map((option) => parseFloat(option.value))
                : [parseFloat(selectedOptions.value)]
              : [];
            handleConditionDetailChange(
              detailIndex,
              "ConditionValue",
              values,
              index
            );
          }}
          formatOptionLabel={formatWindDirectionOption}
          options={detail.selectedCondition.windDirections.map((d) => ({
            value: d.degrees,
            label: d.direction,
          }))}
        />
      </div>
    );
  }
  // Handle numeric inputs

  const convertedValue = (value) =>
    detail.Unit
      ? unitConversions[detail.conditionUnit].conversions
          .find((conversion) => conversion.to === detail.Unit)
          .convert(value)
      : value;

  const revertedValue = (value) =>
    detail.Unit
      ? unitConversions[detail.conditionUnit].conversions
          .find((conversion) => conversion.to === detail.Unit)
          .revert(value)
      : value;

  if (detail.ConditionOperator === "between") {
    return (
      <div className="d-flex gap-2">
        <Input
          key={`${detail.Condition}-min`}
          type="number"
          label="Min Value"
          value={[convertedValue(detail.ConditionValue[0])]}
          onChange={(values) => {
            const min = revertedValue(parseFloat(values[0]));
            const max =
              detail.ConditionValue[1] !== undefined
                ? detail.ConditionValue[1]
                : null;
            handleConditionDetailChange(
              detailIndex,
              "ConditionValue",
              [min, max],
              index
            );
          }}
        />
        <span className="align-self-center">and</span>
        <Input
          key={`${detail.Condition}-max`}
          type="number"
          label="Max Value"
          value={[convertedValue(detail.ConditionValue[1])]}
          onChange={(values) => {
            const min =
              detail.ConditionValue[0] !== undefined
                ? detail.ConditionValue[0]
                : null;
            const max = revertedValue(parseFloat(values[0]));
            handleConditionDetailChange(
              detailIndex,
              "ConditionValue",
              [min, max],
              index
            );
          }}
        />
      </div>
    );
  }

  return (
    <div>
      <InputLabel htmlFor="">Condition Value</InputLabel>
      <input
        autoFocus
        style={{ height: 40 }}
        className="form-control"
        key={detail.Condition + !!detail.ConditionValue[0]}
        type="number"
        label="Condition Value"
        value={convertedValue(detail.ConditionValue[0])}
        max={detail.conditionUnit === "%" ? 100 : null}
        min={
          detail.conditionUnit === "%" ||
          [
            "midnight10MWindSpeed",
            "midday10MWindSpeed",
            "middayVisibility",
            "midnightVisibility",
            "night10MWindGust",
            "day10MWindGust",
            "dayMeanSeaLevelPressure",
            "nightMeanSeaLevelPressure",
          ].includes(detail.Condition)
            ? 0
            : null
        }
        onKeyDown={(e) => {
          if (
            (detail.conditionUnit === "%" ||
              [
                "midnight10MWindSpeed",
                "midday10MWindSpeed",
                "middayVisibility",
                "midnightVisibility",
                "night10MWindGust",
                "day10MWindGust",
                "dayMeanSeaLevelPressure",
                "nightMeanSeaLevelPressure",
              ].includes(detail.Condition)) &&
            (e.code === "Minus" || e.code === "NumpadSubtract" || e.key === "-")
          ) {
            e.preventDefault();
          }
        }}
        onChange={(e) => {
          handleConditionDetailChange(
            detailIndex,
            "ConditionValue",
            e.target.value ? [revertedValue(parseFloat(e.target.value))] : [0],
            index
          );
        }}
      />
    </div>
  );
}

// Helper function for weather code options
const formatWeatherCodeOption = (detail) =>
  function (option) {
    const icon = detail.selectedCondition.codes.find(
      (a) => a.label === option.label
    )?.icon;
    return (
      <div className="d-flex align-items-center gap-2 bg-transparent">
        {icon && (
          <MyIcon
            width="16"
            height="16"
            Icon={icon}
            className="text-purple bg-transparent"
          />
        )}
        {option.label}
      </div>
    );
  };

// Helper function for wind direction options with just cardinal directions
const formatWindDirectionOption = (option) => (
  <div className="d-flex align-items-center gap-2">
    {/* Use FontAwesomeIcon with rotation */}
    <FontAwesomeIcon
      icon={faArrowUp} // Always use faArrowUp as the base icon
      className="text-purple"
      style={{ transform: `rotate(${option.value}deg)` }} // Rotate based on degrees
    />
    {option.label}
  </div>
);

const filterWeatherCodes = (detail) =>
  detail.selectedCondition.codes
    .filter(
      (code) =>
        code.time === null ||
        code.time === (detail.TimeOfDay === "day" ? "day" : "night")
    )
    .map((code) => ({
      value: code.value,
      label: code.label,
    }));

export default WeatherConditionValueSelector;
